import React from 'react';
import {FaWallet, FaBriefcase, FaCog, FaStar, FaGavel, FaSignOutAlt } from 'react-icons/fa';
import {MenuSection, SectionHeader, MenuItem, MenuItemIcon, MenuItemText } from '../Styles/AccountMenuStyles';
import Config from '../../Config';

const OtherMenu = ({ onItemClick, onLogout, displayData }) => {
  return (
    <>
      <MenuSection>
        <SectionHeader>Others</SectionHeader>
        {/* <MenuItem onClick={() => onItemClick('balance')}>
          <MenuItemIcon>
            <FaWallet className="w-5 h-5 text-orange-600" />
          </MenuItemIcon>
          <MenuItemText>Balance</MenuItemText>
        </MenuItem> */}
        <a href={`${Config.sellerDomain}/#/register`}
          target="_blank"
          rel="noopener noreferrer"
          className="no-underline block text-inherit"
        >
          <MenuItem>
            <MenuItemIcon>
              <FaBriefcase className="w-5 h-5 text-kuality-blue" />
            </MenuItemIcon>
            <MenuItemText>Become a Supplier</MenuItemText>
          </MenuItem>
        </a>
        <MenuItem>
          <MenuItemIcon>
            <FaCog className="w-5 h-5 text-kuality-blue" />
          </MenuItemIcon>
          <MenuItemText>Settings</MenuItemText>
        </MenuItem>
        <MenuItem>
          <MenuItemIcon>
            <FaStar className="w-5 h-5 text-kuality-blue" />
          </MenuItemIcon>
          <MenuItemText>Rate us</MenuItemText>
        </MenuItem>
        <MenuItem>
          <MenuItemIcon>
            <FaGavel className="w-5 h-5 text-kuality-blue" />
          </MenuItemIcon>
          <MenuItemText>Legal and Policies</MenuItemText>
        </MenuItem>
        <MenuItem onClick={onLogout}>
          <MenuItemIcon>
            <FaSignOutAlt className="w-5 h-5 text-kuality-blue" />
          </MenuItemIcon>
          <MenuItemText>Logout</MenuItemText>
        </MenuItem>
      </MenuSection>
    </>
  );
};

export default OtherMenu;